import { FunctionComponent, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { BaseInfo, Guid} from "../../../api/baseApi";
import { getBaseChannels } from "../../../api/channelsApi";
import { createPathWithId, Routes } from "../../../constants/routes";
import { Button } from "../../components/Button";
import FormMultiSelect from "../../components/formRow/FormMultiSelect";
import { FormInput, FormRow, SelectOption } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import { RightModal, SmallModal } from "../../components/sideModal/Modal";
import InnerLayout from "../innerLayout/InnerLayout";
import { changeGroupNameForPlayNow, cloneGroupPlayNow, createGroupForPlayNow, createPlayNowList, CreatePlayNowListRequest, deletePlayNowListApi, disablePlayNowGroup, disablePlayNowList, enablePlayNowGroup, enablePlayNowList, getGroupedPlayNowList, getGroupsForPlayNow, getPlayNowLists, GroupedPlayNow, GroupForPlayNowRequest, lockPlayer, PlayNowList, PlayNowListStatus, removeGroupForPlayNow, shufflePlayNowMediaItems, unlockPlayer, updateGroupForPlayNow, updatePlayNowList, UpdatePlayNowListRequest } from "../../../api/playNowListApi"
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import PlayNowFullscreen from "../../components/playNowFullscreen/PlayNowFullscreen";
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";
import { useErrorHandlingStore } from "../../../hooks/useErrorHandling";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import Select, { MultiValue, SingleValue } from "react-select";
import { getTags } from "../../../api/tagApi";
import Tabs, { TabElement, TabNavigation, TabNavigationElement, TabsContainer } from "../../components/tab/Tab";
import PlayNowLogs from "../../components/playNowLogs/PlayNowLogs";
import { formatTimeOnly } from "../../../services/dateService";

interface PlayNowListProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type SettingsTab = "List" | "Logs" ;

type ModalAction = "create" | "update" | "set" | "clone" | "delete" | "nothing" | "shuffle";
type Option<T> = { value: T, label: string}
interface CheckedItems {
    [key: string]: boolean;
}
 
const CurrentPlayList: FunctionComponent<PlayNowListProps> = (props : PlayNowListProps) => {
    let [isLoading, setIsLoading] = useState<boolean>(false);

    let [playNowLists, setPlayNowLists] = useState<PlayNowList[]>([]);
    let [playNowChannels, setplayNowChannels] = useState<BaseInfo[]>([]);
    let [playNowChannelOptions, setPlayNowChannelOptions] = useState<SelectOption[]>([]);

    let [playNowShowModal, setPlayNowShowModal] = useState<boolean>(false);

    let [playNowListName, setPlayNowListName] = useState<string>("");
    let [playNowListNameError, setPlayNowListNameError] = useState<boolean>(false);
    let [playNowSelectedChannels, setPlayNowSelectedChannels] = useState<Guid[]>([]);
    let [playNowListIdForEdit, setPlayNowListIdForEdit] = useState<Guid>();

    let [isShowSmallModalDeletePlayNowList, setIsShowSmallModalDeletePlayNowList] = useState(false);
    let [itemIdForDelete, setItemIdForDelete] = useState<Guid>('');
    let [itemNameForDelete, setItemNameForDelete] = useState<string>('');

    let [currentPagePlayNow, setCurrentPagePlayNow] = useState<number>(1);

    let [isUseOrRelationshipInPlayNow, setIsUseOrRelationshipInPlayNow] = useState(false);
    let [tags,setTags] = useState<BaseInfo[]>([]);
    let [includedTags, setIncludedTags] = useState<BaseInfo[]>([]);
    let [excludedTags, setExcludedTags] = useState<BaseInfo[]>([]);
    let [autoDeactivationTime, setAutoDeactivationTime] = useState("");

    let [activeTab, setActiveTab] = useState<SettingsTab>("List")

    //group
    let [groupedPlayNowList, setGroupedPlayNowList] = useState<GroupedPlayNow[]>([])
    let [groupedListItemsToDisplay, setGroupedListItemsToDisplay] = useState<GroupedPlayNow[]>([])
    let [isShowGroupModal, setIsShowGroupModal] = useState(false)
    let [playNowGroups, setPlayNowGroups ] = useState<Option<Guid>[]>([]);
    let [selectedPlayNowGroup, setSelectedPlayNowGroup] = useState<Guid>('');
    let [groupName, setGroupName] = useState("");
    let [isGroupNameError, setIsGroupNameError] = useState(false);
    let [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    let [groupModalAction, setGroupModalAction] = useState<ModalAction>("nothing");
    let [itemIdForAction, setItemIdForAction] = useState<Guid>("");

    let [checkedItems, setCheckedItems] = useState<CheckedItems>({});
    
    let itemsPerPage = 5;

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            await Promise.all([getList(),getChannelsForList(),updateTags(), updateGroups()]);
            setIsLoading(false);
        };
        fetchData();
    }, []);

    useEffect(() => {
        async function fetchData() {
            if(activeTab === "List"){
                setIsLoading(true);
                await Promise.all([getList(),getChannelsForList(),updateTags()]);
                setIsLoading(false);
            }
        };
        fetchData();
    }, [activeTab]);

    useEffect(() => {
        let startIndex = (currentPagePlayNow - 1)*itemsPerPage;
        let finishIndex = startIndex + itemsPerPage;
        setGroupedListItemsToDisplay(groupedPlayNowList.slice(startIndex, finishIndex));
    }, [groupedPlayNowList, currentPagePlayNow]);

    useEffect(() =>{
        const initialCheckedItems: CheckedItems = {};
        groupedPlayNowList.forEach(item => {
            if(checkedItems[item.groupId] === undefined){
                initialCheckedItems[item.groupId] = true
            } else {
                initialCheckedItems[item.groupId] = checkedItems[item.groupId]
            }
        });
        setCheckedItems(initialCheckedItems);
    },[groupedPlayNowList])

    const getList = async () => {
        setIsLoading(true);
        var result = await getGroupedPlayNowList();
        if(result.type == 'succes'){
            setGroupedPlayNowList(result.data.items);
        }
        setIsLoading(false);
    }

    const getChannelsForList = async () => {
        var channelsResult = await getBaseChannels();
        if(channelsResult.type == "succes"){
            setplayNowChannels(channelsResult.data.items);
        }
    }

    const updateGroups = async () => {
        let response = await getGroupsForPlayNow();
        if( response.type === "succes") {
            let t = response.data.items.map( el => {
                return {
                    label: el.name,
                    value: el.id
                }
            })
            setPlayNowGroups(t);
        }
    }

    const mapChannelToOption = (it: BaseInfo) : SelectOption => {
        return {value: it.id, name: it.name};
   }

    const showCreateModalPlayNow = () => {
        setPlayNowChannelOptions(playNowChannels.map(mapChannelToOption));
        setPlayNowShowModal(true);
    }

    const closeModalPlayNow = () => {
        setPlayNowListIdForEdit(undefined);
        setPlayNowListName('');
        setPlayNowSelectedChannels([]);
        setPlayNowShowModal(false);
        setIncludedTags([]);
        setExcludedTags([]);
        setIsUseOrRelationshipInPlayNow(false);
        setAutoDeactivationTime("")
    }

    const showEditModalPlayNow = (playNow: PlayNowList) => {
        setPlayNowChannelOptions([...playNowChannels, ...playNow.channels].map(mapChannelToOption));
        setPlayNowListName(playNow.name);
        setPlayNowSelectedChannels(playNow.channels.map(it => it.id));
        setPlayNowListIdForEdit(playNow.id);
        setIncludedTags( tags.filter(it => playNow.includeTagIds.some(it2 => it2.id === it.id)))
        setExcludedTags( tags.filter(it => playNow.excludeTagIds.some(it2 => it2.id === it.id)))
        setIsUseOrRelationshipInPlayNow(playNow.useORRelationshipForIncludeTags)
        setAutoDeactivationTime(playNow.autoDeactivationTime)
        setPlayNowShowModal(true);
    }

    const onAddChannelPlayNow = (id: Guid) => {
        setPlayNowSelectedChannels([...playNowSelectedChannels, id]);
    } 

    const onRemoveChannelPlayNow = (id: Guid) => {
        setPlayNowSelectedChannels(playNowSelectedChannels.filter(it => it !== id));
    }

    const deletePlayNowListConfirm = async (id:Guid) => {
        setIsLoading(true);
        setItemIdForDelete(id);
        await deletePlayNowListApi(id);
        await getList();
        await getChannelsForList();
        closeSmallModalPlayNow();
        setIsLoading(false);
    }

    const saveListPlayNow = async () => {
        if(playNowListName === "" || playNowListName === undefined){
            setPlayNowListNameError(true);
            return;
        }
        if(playNowListIdForEdit === undefined){
            let request : CreatePlayNowListRequest = { 
                channelIds: playNowSelectedChannels, 
                name: playNowListName,
                includeTagIds: includedTags.map( it => it.id),
                excludeTagIds: excludedTags.map( it => it.id),
                useORRelationshipForIncludeTags: isUseOrRelationshipInPlayNow,
                autoDeactivationTime: autoDeactivationTime
            };
            await createPlayNowList(request);
            setPlayNowListName('');
            setPlayNowSelectedChannels([]);
        }
        else{
            let request : UpdatePlayNowListRequest =  { 
                channelIds: playNowSelectedChannels, 
                name: playNowListName,
                includeTagIds: includedTags.map( it => it.id),
                excludeTagIds: excludedTags.map( it => it.id),
                useORRelationshipForIncludeTags: isUseOrRelationshipInPlayNow,
                autoDeactivationTime: autoDeactivationTime
            };
            await updatePlayNowList(request, playNowListIdForEdit);
            setPlayNowListName('');
            setPlayNowSelectedChannels([]);
        }
        await getList();
        await getChannelsForList();
        closeModalPlayNow();
    }

    const activatePlayNow = async (id: Guid) => {
        await enablePlayNowList(id);
        await getList();
    }
    
    const inactivatePlayNow = async (id: Guid) => {
        await disablePlayNowList(id);
        await getList();
    }

    const activatePlayNowGroup = async (groupId: Guid) => {
        setIsLoading(true);
        await enablePlayNowGroup(groupId);
        await getList();
        setIsLoading(false);
    }

    const inactivatePlayNowGroup = async (groupId: Guid) => {
        setIsLoading(true);
        await disablePlayNowGroup(groupId);
        await getList();
        setIsLoading(false);
    }

    const renderStatusPlayNow = (status: PlayNowListStatus) => {
        switch(status){
            case PlayNowListStatus.Active : return <span className="status-active">Active</span>
            case PlayNowListStatus.Inactive : return <span className="status-paused">Inactive</span>
        }
    }

    const updatePlayerLockStatus = async (playlistId: Guid, playerId: Guid, isLocked: boolean) => {
        setIsLoading(true)
        if(isLocked){
            await unlockPlayer(playlistId, playerId)
            } else {
            await lockPlayer(playlistId, playerId)
        }
        await getList();
        setIsLoading(false)
    }

    const renderPlayNowRow = (item: PlayNowList) => {
        return <tr key={item.id}>
        <td>{item.name}</td>
        <td>{item.channels.map(it => <p key={it.id}>{it.name}</p>)}</td>
        <td>{renderStatusPlayNow(item.status)}</td>
        <td>
            <div className="d-flex gap5">
                <div style={{paddingRight: '5px'}}>
                    {item.includeTagIds.map((it, i) => <p key={i}>{it.name}</p>)}
                </div>
                <div style={{color: "#717c76"}}>
                    {item.excludeTagIds.map((it, i) => <p key={i}>{it.name}</p>)}
                </div>
            </div>
            {item.useORRelationshipForIncludeTags && <div className="d-flex align-items-center" style={{color:"#2DCC3D"}}>
                Contain any tags
            </div>} 
        </td>
        <td>{item.players.map(p => {
            return <p key={p.id}>
                {p.name}
                <span className={`${p.isLocked ? "" : "opacity-50"}`}>
                    <IconButton type="lock" tooltipText={`${p.isLocked ? "Unlock" : "Lock"}`} onClick={()=>{updatePlayerLockStatus(item.id, p.playerId, p.isLocked)}}/>
                </span>
            </p>
        })}
        </td>
        <td>{formatTimeOnly(item.autoDeactivationTime)}</td>
        <td> 
            { 
                item.status == PlayNowListStatus.Active 
                &&  <IconButton tooltipText="Stop" type="stop-play" onClick={() => inactivatePlayNow(item.id)} />
            }
             { 
                item.status == PlayNowListStatus.Inactive 
                &&  <IconButton tooltipText="Play" type="play" onClick={() => activatePlayNow(item.id)} />
            }
           
            <IconButton tooltipText="Set Group" type="folder" onClick={() => {showGroupModal("set"); setItemIdForAction(item.id)}} />
            <IconButton tooltipText="Edit" type="edit" onClick={() => {showEditModalPlayNow(item)}}/>
            <IconButton tooltipText="Media" type="list-add" onClick={()=>{props.history.push(createPathWithId(Routes.PlayNow, item.id))}}/>
            <IconButton tooltipText="Delete" type="delete" onClick={()=>showSmallModalPlayNow(item.id, item.name)} />
        </td>
        </tr>
    }

    const renderGroupedPlayNowRow = (items: GroupedPlayNow[]) => {
        return items.map((item, index) => {
            const hasActivePlayNow = item.playNowLists.some(playNow => playNow.status === PlayNowListStatus.Active);
            const hasInactivePlayNow = item.playNowLists.some(playNow => playNow.status === PlayNowListStatus.Inactive);

            return <tr className="no-hover" key={item.groupId}>
            <td colSpan={11} className="group-media-block" style={{textAlign:'left', padding:"0 0 15px 30px"}}>
                <div className="group-title">
                    {item.name} 
                    {!!item.groupId && <>
                    <IconButton tooltipText="Play Group" type="play" disabled={!hasInactivePlayNow} onClick={() => activatePlayNowGroup(item.groupId)}/>
                    <IconButton tooltipText="Stop Group" type="stop-play" disabled={!hasActivePlayNow} onClick={() => inactivatePlayNowGroup(item.groupId)}/>
                    <IconButton tooltipText="Clone" type="copy" onClick={() => showConfirmModal(item.groupId, "clone")}/>
                    <IconButton tooltipText="Edit" type="edit" onClick={() => showGroupModal("update", item)}/>
                    <IconButton tooltipText="Delete" type="delete" onClick={() => showConfirmModal(item.groupId, "delete")}/>
                    <IconButton tooltipText="Shuffle" type="shuffle" onClick={() => showConfirmModal(item.groupId, "shuffle")}/>
                    </>}
                    <div className="d-inline-flex justify-content-end" style={{marginLeft:30}}>
                        <label htmlFor={`group-${item.groupId}`} className="checkbox-control" >
                            <input 
                                id={`group-${item.groupId}`} 
                                className="checkbox" 
                                type="checkbox" 
                                checked={!!checkedItems[item.groupId]}
                                onChange={() => handleCheckboxChange(item.groupId)}
                            />
                            <span className="checkbox-bg"></span>
                            <span className="checkbox-cursor"></span>
                        </label>
                        <span className="current-status">&nbsp;Expand</span>
                    </div>
                </div>
                <tbody>
                    {item.playNowLists.map(renderPlayNowRow)}
                </tbody>
            </td>
        </tr>
        })
    }

    

    const showSmallModalPlayNow = (id:Guid, name: string) => {
        setItemIdForDelete(id);
        setItemNameForDelete(name);
        setIsShowSmallModalDeletePlayNowList(true);
    }

    const closeSmallModalPlayNow = () => {
        setItemIdForDelete('');
        setItemNameForDelete('');
        setIsShowSmallModalDeletePlayNowList(false);
    }

    const handle = useFullScreenHandle();

    const goToFullscreen = () =>{
        handle.enter();
    }

    const exitFullscreen = () =>{
        handle.exit();
    }

    const updateTags = async () => {
        let tagResponse = await getTags();
        if(tagResponse.type == "succes") {
            setTags(tagResponse.data.items)
        }
    }

    const onSelectedIncludeTag = (tags: MultiValue<BaseInfo>) => {
        setIncludedTags([...tags])
    }

    const onSelectedExcludeTag = (tags: MultiValue<BaseInfo>) => {
        setExcludedTags([...tags])
    }

    const checkActive = (tab: SettingsTab) =>  tab === activeTab;

    const showGroupModal = (action: ModalAction, item?: GroupedPlayNow) => {
        if(item){
            setGroupName(item.name)
            setItemIdForAction(item.groupId)
        }
        setGroupModalAction(action)
        setIsShowGroupModal(true)
    }

    const hideGroupModal = () => {
        setSelectedPlayNowGroup("")
        setIsGroupNameError(false)
        setGroupModalAction("nothing")
        setGroupName("")
        setItemIdForAction("")
        setIsShowGroupModal(false)
    }

    const createNewGroupForPlayNow = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            return;
        }
        
        let request = {name:groupName};
        setIsLoading(true)
        await createGroupForPlayNow(request)
        await updateGroups()
        setIsLoading(false)
        hideGroupModal()
    }

    const updateGroupName = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            return;
        }
        
        let request = {name:groupName};
        setIsLoading(true)
        await changeGroupNameForPlayNow(request, itemIdForAction)
        await updateGroups()
        await getList()
        setIsLoading(false)
        hideGroupModal()
    }

    const saveGroupForPlayNow = async () => {
        let request: GroupForPlayNowRequest = {
            groupId: selectedPlayNowGroup ? selectedPlayNowGroup : null,
        }
        setIsLoading(true)
        await updateGroupForPlayNow(request, itemIdForAction)
        await getList()
        setIsLoading(false)
        hideGroupModal()
    }

    const onChangeSelectedPlayNowGroup = (group: SingleValue<Option<Guid>>) => {
        if(group){
            setSelectedPlayNowGroup(group.value);
        } else {
            setSelectedPlayNowGroup('');
        }
    }

    const handleCheckboxChange = (id: string) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const showConfirmModal = (id: Guid, action: ModalAction) => {
        setItemIdForAction(id);
        setGroupModalAction(action)
        setIsShowConfirmModal(true);
    }

    const closeConfirmModal = () => {
        setItemIdForAction("");
        setGroupModalAction("nothing")
        setIsShowConfirmModal(false);
    }

    const cloneGroup = async () => {
        setIsLoading(true)
        await cloneGroupPlayNow(itemIdForAction)
        await updateGroups()
        await getList()
        setIsLoading(false)
        closeConfirmModal()
    }

    const deleteGroup = async () => {
        setIsLoading(true)
        await removeGroupForPlayNow(itemIdForAction)
        await updateGroups()
        await getList()
        setIsLoading(false)
        closeConfirmModal()
    }

    const shuffleItemsInGroup = async () => {
        setIsLoading(true)
        await shufflePlayNowMediaItems(itemIdForAction)
        await updateGroups()
        await getList()
        setIsLoading(false)
        closeConfirmModal()
    }

    return (  
    <InnerLayout 
        isCollapsed={props.isCollapsed}
        logOut={props.logOut}
        toogleCollapse={props.toogleCollapse}
        activeTab="playNowList">
            <>
                <div className="d-flex justify-content-between align-items-center mb-20 pt-50" >
                    <h2>Play Now</h2>
                </div>
                
                <Tabs>
                    <TabNavigation>
                        <TabNavigationElement 
                            title="Playlists" 
                            isActive={checkActive("List")} 
                            onClick={() => { setActiveTab("List") }} 
                        />
                        <TabNavigationElement 
                            title="Logs" 
                            isActive={checkActive("Logs")} 
                            onClick={() => { setActiveTab("Logs") }} 
                        />
                    </TabNavigation>
                    <TabsContainer>
                        <TabElement isActive={checkActive("List")}>
                            <>
                            <div className="d-flex justify-content-end align-items-center gap15 w-100 mb-20" >
                                <Button color="green"  label="Add Group" onClick={() => {showGroupModal("create")}} />
                                <Button color="green"  label="Enter Fullscreen Mode" onClick={goToFullscreen} />
                                <Button color="green"  label="Add Play Now" onClick={showCreateModalPlayNow} />
                            </div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <td>Name</td>
                                        <td>Networks</td>
                                        <td>Status</td>
                                        <td>Include/Exclude Tags</td>
                                        <td>Players</td>
                                        <td>Auto Deactivation Time</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderGroupedPlayNowRow(groupedListItemsToDisplay)}
                                </tbody>
                            </table>

                            <Pagination activePage={currentPagePlayNow} pagesCount={getPagesCount(groupedPlayNowList.length, itemsPerPage)} changePaginationPage={setCurrentPagePlayNow} />
                            </>
                        </TabElement>
                        <TabElement isActive={checkActive("Logs")}>
                            <>
                                {checkActive("Logs") && <PlayNowLogs />} 
                            </>
                        </TabElement>
                    </TabsContainer>
                </Tabs>


                <FullScreen handle={handle}>
                    <PlayNowFullscreen 
                        // playNowLists={playNowLists} 
                        playNowLists={groupedPlayNowList.flatMap(el => el.playNowLists)} 
                        isLoading={isLoading}
                        activatePlayNow={activatePlayNow} 
                        inactivatePlayNow={inactivatePlayNow} 
                        exitFullscreen={exitFullscreen} 
                    />
                </FullScreen>

                <RightModal title={playNowListIdForEdit === undefined ? "Add Play Now" : "Edit Play Now"} 
                    show={playNowShowModal}
                    onRequestClose={closeModalPlayNow}
                    >
                        <FormRow>
                            <FormInput 
                                id="campaign-name"
                                title="Play Now Name"
                                isError={playNowListNameError}
                                errorMessage="Please enter Play Now Name"
                                onChange={e => { setPlayNowListName(e.target.value); setPlayNowListNameError(false);}}
                                value={playNowListName}
                            />
                        </FormRow>
                        <FormRow>
                            <FormMultiSelect
                                    id="players-list"
                                    title="Networks"
                                    titleSelected="Selected Networks"
                                    isError={false}
                                    errorMessage="Please select Networks"
                                    onAdd={onAddChannelPlayNow}
                                    onRemove={onRemoveChannelPlayNow}
                                    options={playNowChannelOptions}
                                    selectedOptions={playNowSelectedChannels}
                                />
                        </FormRow>  
                        <FormRow>
                            <div className="d-flex align-items-center" style={{paddingTop:"30px"}}>
                                <FormCheckbox id="use-or-playnow" checked={isUseOrRelationshipInPlayNow} onChange={setIsUseOrRelationshipInPlayNow} />
                                <span className="status-block">
                                    {isUseOrRelationshipInPlayNow ? <span className="current-status online">&nbsp;Contain any tags</span> : <span className="current-status offline">&nbsp;Contain any tags</span>}
                                </span>
                            </div>
                        </FormRow>
                        <FormRow>
                            <label>Included Tags</label>
                            <Select 
                                classNamePrefix={`select`}
                                options={tags.filter(it => !excludedTags.some( it2 => it2.id === it.id))} 
                                isMulti={true}
                                filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option)=> `${option.id}`}
                                onChange={onSelectedIncludeTag}
                                value={includedTags}
                            />    
                        </FormRow>
                        <FormRow>
                            <label>Excluded Tags</label>
                            <Select 
                                classNamePrefix={`select`}
                                options={tags.filter(it => !includedTags.some( it2 => it2.id === it.id))} 
                                isMulti={true}
                                filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option)=> `${option.id}`}
                                onChange={onSelectedExcludeTag}
                                value={excludedTags}
                            />    
                        </FormRow>
                        <FormRow>
                            <FormInput
                                errorMessage=""
                                id="auto_deactivation_time"
                                isError={false}
                                type="time"
                                onChangeValue={(v) => { console.log("!!!!",v); setAutoDeactivationTime(v)}}
                                value={autoDeactivationTime}
                                title="Auto Deactivation Time"
                            />  
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={saveListPlayNow}/>
                            <Button color="gray" label="Cancel" onClick={closeModalPlayNow}/>
                        </div>
                </RightModal>

                <RightModal title={`${groupModalAction === "create" ? "Add" : "Set"} Group`} show={isShowGroupModal} onRequestClose={hideGroupModal}>
                    <FormRow>
                        {groupModalAction === "set" && <><label>Groups</label>
                        <Select 
                            options={playNowGroups}
                            classNamePrefix={`select`}
                            onChange={onChangeSelectedPlayNowGroup} 
                            isClearable={true}
                        /></>}
                        {(groupModalAction === "create" || groupModalAction === "update") && <FormInput 
                            errorMessage = "Please enter Group Name"
                            id = "media_group_name"
                            isError = {isGroupNameError}
                            title = "Group Name"
                            onChangeValue = {(v) => {setGroupName(v); setIsGroupNameError(false)}}
                            value = {groupName}
                        />}
                    </FormRow>
                    <div className="modal-btn-group">
                        {groupModalAction === "set" && <Button color="green" label="Save" onClick={saveGroupForPlayNow}/>}
                        {groupModalAction === "update" && <Button color="green" label="Save" onClick={updateGroupName}/>}
                        {groupModalAction === "create" && <Button color="green" label="Add" onClick={createNewGroupForPlayNow}/>}
                        <Button color="gray" label="Cancel" onClick={hideGroupModal}/>
                    </div>
                </RightModal>  

                <SmallModal show={isShowSmallModalDeletePlayNowList} onRequestClose={closeSmallModalPlayNow}> 
                    <p>That you want to delete list <b>{itemNameForDelete}</b>?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeSmallModalPlayNow}/>
                        <Button color="green" label="Yes" onClick={()=>deletePlayNowListConfirm(itemIdForDelete)}/>
                    </div>
                </SmallModal>

                <SmallModal show={isShowConfirmModal} onRequestClose={closeConfirmModal}> 
                    {groupModalAction === "clone" && <p>That you want to {`${groupModalAction}`} Group?</p>}
                    {groupModalAction === "delete" && <p>That you want to {`${groupModalAction}`} Group?</p>}
                    {groupModalAction === "shuffle" && <p>That you want to shuffle media items?</p>}
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeConfirmModal}/>
                        {groupModalAction === "clone" && <Button color="green" label="Yes" onClick={cloneGroup}/>}
                        {groupModalAction === "delete" && <Button color="green" label="Yes" onClick={deleteGroup}/>}
                        {groupModalAction === "shuffle" && <Button color="green" label="Yes" onClick={shuffleItemsInGroup}/>}
                    </div>
                </SmallModal>

                <GlobalSpinner isShow={isLoading} />
            </>
           
    </InnerLayout> );
}
 
export default withRouter(CurrentPlayList);
